import apiService from '../apiService'

const apiPath = '/color'

export const colorController = (configService) => {
	const service = apiService(configService)
	return {
		getColorDd: () => {
			return service.get({
				url: `${apiPath}/get_color_dd`,
			})
		},
		getColorThaisri: () => {
			return service.get({
				url: `${apiPath}/get_color_thaisri`,
			})
		},
		getColorRvp: () => {
			return service.get({
				url: `${apiPath}/get_color_rvp`,
			})
		},
		getColorFCI: () => {
			return service.get({
				url: `${apiPath}/get_color_fci`,
			})
		},
		getColorViriya: () => {
			return service.get({
				url: `${apiPath}/get_color_viriya`,
			})
		},
		getColorDvs: () => {
			return service.get({
				url: `${apiPath}/get_color_dvs`,
			})
		},
	}
}
